import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { translationNamespace } from '@/lib/config';
import { ChannelContext } from '@/components/channel/Channel';
import ActiveLink from '../ActiveLink';
import styles from './styles.module.scss';

interface IProps {
  inOverlay?: boolean;
}

const MainMenu: React.FC<IProps> = (props) => {
  const { t } = useTranslation(translationNamespace);
  const { channelId } = useContext(ChannelContext);
  return (
    <ul className={[styles['main-menu'], ...(props.inOverlay ? [styles['main-menu-in-overlay']] : [])].join(' ')}>
      {[
        {
          href: `/${channelId}/outlets`,
          label: t('outlets.title'),
        },
        {
          href: `/${channelId}/furniture`,
          label: t('furniture.title'),
        },
        {
          href: `/${channelId}/administration`,
          label: t('administration.title'),
        },
        {
          href: `/${channelId}/paywalls`,
          label: t('paywalls.title'),
        },
        {
          href: `/${channelId}/surveys`,
          label: t('surveys.title'),
        },
      ].map((item) => (
        <li key={item.label}>
          <ActiveLink
            href={item.href}
            activeClassName="active"
          >
            <a>{item.label}</a>
          </ActiveLink>
        </li>
      ))}
    </ul>
  );
};

export default MainMenu;
